<template>
    <div class="pcselect-template" ref="selectTplContainer" @scroll="handleScroll" @mousewheel="goBackHome">
        <div class="header" ref="pcselect_header" :class="{ fixed: !showTopBackButton }">
            <transition name="move-up">
                <div class="top-button" v-show="showTopBackButton" @click="backHome">
                    <iconSymbol class="icon" name="pc-arrow-up" />
                    {{ $t("scrollTop") }}
                </div>
            </transition>
            <h2 class="title">{{ $t("templates") }}</h2>
            <div class="tabs">
                <div class="item" v-for="item in tabs" :key="item.id" :class="{ active: activeTab.id == item.id }" @click="changeAcitve(item)">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <tplWaterfall :style="{ marginTop: !showTopBackButton ? headerHeight + 'px' : 0 }" ref="waterfall" :works="works" type="center" />
        <loading v-show="state.loading && !state.loadEnd" />
        <!-- 返回首页按钮 -->
        <div class="slider-btn">
            <div class="to-home" :class="{ dark: isPCDarkMode == 2 }" @click="backHome">
                <iconSymbol class="icon" :class="{ dark: isPCDarkMode == 2 }" name="pc-toHome" />
                <p>{{ $t("home") }}</p>
            </div>
            <div class="to-top" v-show="!showTopBackButton" :class="{ dark: isPCDarkMode == 2 }" @click="backTop">
                <iconSymbol class="icon" :class="{ dark: isPCDarkMode == 2 }" name="pc-toTop" />
                <p>{{ $t("top") }}</p>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import groupBy from "lodash/groupBy";
    import find from "lodash/find";
    import loading from "@/public/components/loading.vue";
    import tplCenter from "@/home/mixins/tplCenter";
    import { PublicType } from "@/home/hooks/enum";
    @Component({
        components: {
            loading,
        },
    })
    export default class PCHomeTemplates extends Mixins(tplCenter) {
        state = {
            current: 1,
            size: 20,
            order: "PV",
            type: "all",
            loading: false,
            loadEnd: false,
        };
        classId = 0;
        activeTab = {
            id: 0,
            name: "",
        };
        tabs = [];
        async changeAcitve(item) {
            this.activeTab.id = item.id;
            this.activeTab.name = item.id > 0 ? item.name : "";
            this.state.current = 1;
            if (window.screenY != 0) {
                window.scrollTo(1, 0);
            }
            this.clearWaterfall();
            this.getTemplates();
        }
        tags = [];
        getClassIdByName(item: { galleryName: string; galleryNameU: string; templateName: string; templateNameU: string }) {
            let name = item.galleryName,
                nameU = item.galleryNameU,
                _name = item.templateName,
                _nameU = item.templateNameU;
            _nameU = _nameU == "Floor Plan" ? "Floor Plan2" : _nameU;
            nameU = nameU == "Floor Plan" ? "Floor Plan1" : nameU;
            const key = _nameU || nameU;
            const list = groupBy(this.tags, (i) => i.lv1id === 0);
            const lv1s = list["false"];
            const lv2s = lv1s.reduce((prev, current) => [...prev, ...(current?.lv2 || [])], []);
            const lv3s = lv2s.reduce((prev, current) => [...prev, ...(current?.lv3 || [])], []);
            let activeLv3 = find(lv3s, (i) => i.lv3name == _nameU);
            activeLv3 = !activeLv3 ? find(lv3s, (i) => i.lv3name == nameU) : activeLv3;
            let activeLv2 = !activeLv3 && find(lv2s, (i) => i.lv2name == _nameU);
            activeLv2 = !activeLv2 ? find(lv2s, (i) => i.lv2name == nameU) : activeLv2;
            let activeLv1 = !activeLv2 && find(lv1s, (i) => i.lv1name == nameU);
            return PublicType.class[key] || activeLv3?.lv3id || activeLv2?.lv2id || activeLv1?.lv1id;
        }
        async getTemplates() {
            this.state.loading = true;
            this.state.loadEnd = false;
            const params = {
                offset: (this.state.current - 1) * this.state.size,
                count: this.state.size,
                order: this.state.order,
                sort: "DESC",
                lang: "zh",
                classId: this.classId,
                price: 1,
                reduce: 1,
                type: this.state.type,
                search: this.activeTab.name,
                tag: [],
            };
            return new Promise((resolve) => {
                this.$edApi
                    .getPublish(params)
                    .then(({ data }) => {
                        console.log("data", data);
                        const _data = data || [];
                        this.state.loadEnd = _data.length < this.state.size;
                        this.updateWaterfall({
                            works: _data,
                            noCache: null,
                            callback: () => {
                                if (data.length < 20) {
                                    //小于20个说明已全部显示
                                    this.state.loadEnd = true;
                                }
                                this.state.loading = false;
                                resolve();
                            },
                        });
                    })
                    .catch((err) => {
                        console.log("getTemplates err", err);
                        resolve();
                    });
            });
        }
        backHome() {
            (<any>window).$qt.jsCallBackToHomePage();
        }
        backTop() {
            (this.$refs.selectTplContainer as HTMLElement).scrollTop = 0;
        }
        showTopBackButton = true;
        addTemplates() {
            try {
                this.state.current++;
                this.getTemplates();
            } catch (error) {
                console.log(error);
                this.state.loadEnd = false;
                this.state.loading = false;
            }
        }
        handleScroll(event) {
            const domScrollTop = event.target.scrollTop || 0;
            const domClientHeihgt = event.target.clientHeight || 0;
            const domScrollHeight = event.target.scrollHeight || 0;
            if (domScrollHeight - domClientHeihgt < 34) return; // 34为top-button的高度
            this.showTopBackButton = domScrollTop <= 0;
            this.headerHeight = (this.$refs["pcselect_header"] as HTMLElement).offsetHeight;
            if (this.state.loading || this.state.loadEnd) return;
            if (domScrollTop + domClientHeihgt >= domScrollHeight) {
                this.addTemplates();
            }
        }
        async getTag() {
            return new Promise((resolve) => {
                const _tabs = [
                    {
                        id: 0,
                        name: `${this.$t("all")}${this.templateName || this.galleryName || ""}`,
                    },
                ];
                this.$edApi
                    .getTplRecommendWords({
                        class_id: this.classId,
                    })
                    .then((data) => {
                        _tabs.push(
                            ...data.words.map((item, index) => {
                                return { id: index + 1, name: item };
                            })
                        );
                        this.tabs = _tabs;
                        resolve();
                    })
                    .catch(() => {
                        this.tabs = _tabs;
                    });
            });
        }
        scrollDistance = 0;
        times = 0;
        goBackHome(event: any) {
            let delta = event.deltaY || event.detail || event.wheelDelta;
            if (this.showTopBackButton && event.deltaY < 0) {
                this.scrollDistance += delta;
                this.times++;
                if (this.scrollDistance <= -400 && this.times >= 4) {
                    // 调用桌面端事件回到首页
                    (<any>window).$qt.jsCallBackToHomePage();
                    this.scrollDistance = 0;
                    this.times = 0;
                }
            }
        }
        get home_templates_name() {
            return JSON.parse(sessionStorage.getItem("home_templates_name") || "{}");
        }
        galleryName = "";
        galleryNameU = "";
        templateName = "";
        templateNameU = "";
        resetData() {
            this.state.current = 1;
            this.activeTab.id = 0;
            this.activeTab.name = "";
            this.clearWaterfall();
        }
        async initData(item: { GalleryName: string; GalleryNameU: string; TemplateName: string; TemplateNameU: string }) {
            this.$store.commit("setState", {
                type: "trackTemplateWay",
                data: "fromEmbeddTemplateScroll",
            });
            this.galleryName = item.GalleryName || "";
            this.galleryNameU = item.GalleryNameU || "";
            this.templateName = item.TemplateName || "";
            this.templateNameU = item.TemplateNameU || "";
            this.resetData();
            this.classId = this.getClassIdByName({
                galleryName: this.galleryName,
                galleryNameU: this.galleryNameU,
                templateName: this.templateName,
                templateNameU: this.templateNameU,
            });
            console.log("classId", this.classId);
            this.getTemplates();
            this.getTag();
        }
        inited = false;
        headerHeight = 0;
        async handleInit(item) {
            this.inited = true;
            if (!this.tags.length) {
                this.tags = await this.$edApi.getTagClass({
                    lang: this.lang,
                });
            }
            this.initData(item);
        }
        async mounted() {
            this.$bus.$on("homeTemplates", this.handleInit);
            if (!this.tags.length) {
                this.tags = await this.$edApi.getTagClass({
                    lang: this.lang,
                });
            }
            if (!this.inited) this.initData(this.home_templates_name);
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }
        beforeDestroy() {
            this.$bus.$off("homeTemplates", this.handleInit);
        }
    }
</script>
<style lang="stylus" scoped>
    .pcselect-template {
    	padding: 16px 24px 0;
    	background: var(--backgroudColor);
    	height: 100%;
    	overflow-y: scroll;
    	position: flex;
    	&::-webkit-scrollbar {
    		width: 8px;
    		height: 6px;
    		pointer-events: none;
    		background: var(--backgroudColor);
    	}

    	&::-webkit-scrollbar-thumb {
    		background: var(--scrollBackground);
    		border-radius: 4px;
    	}

    	.mo-waterfall {
    		color: var(--fontTemplateTitleColor);

    		/deep/.mo-work {
    			.mo-work--number-area {
    				span {
    					color: var(--fontTemplateDescTitleColor);
    				}

    				.mo-work--numbers {
    					.mo-ex--icon {
    						svg {
    							fill: var(--iconTemplateColor);
    						}
    					}

    					>div {
    						svg {
    							fill: var(--iconTemplateColor);
    							stroke: var(--iconTemplateColor);
    						}
    					}
    				}
    			}
    		}
    	}

    	.header {
    		display: flex;
    		flex-direction: column;

    		&.fixed {
    			position: fixed;
    			top: 0;
    			left: 16px;
    			right: 16px;
    			z-index: 2;
    			padding-top: 24px;
    			background: var(--backgroudColor);
    		}

    		.top-button {
    			padding: 8px 16px;
    			display: inline-flex;
    			align-items: center;
    			border-radius: 30px;
    			font-size: 14px;
    			font-weight: 400;
    			line-height: 18px;
    			color: #017fff;
    			cursor: default;
    			margin: 0 auto 16px;
    			position: relative;
    			background: var(--backgroudTopBtnColor);

    			.icon {
    				width: 14px;
    				height: 18px;
    				margin-right: 8px;
    			}
    		}

    		.title {
    			color: var(--fontTitleColor);
    			font-size: 16px;
    			font-weight: 700;
    			line-height: 20px;
    			margin-bottom: 24px;
    		}

    		.tabs {
    			display: flex;
    			align-items: center;
    			flex-wrap: wrap;
    			margin-bottom: 12px;

    			.item {
    				cursor: default;
    				padding: 6px 16px;
    				border-radius: 4px;
    				color: var(--fontTabColor);
    				background: var(--backgroudTabColor);
    				margin-right: 12px;
    				margin-bottom: 12px;

    				&:hover, &.active {
    					background: #017fff14;
    					color: #017fff;
    				}
    			}
    		}
    	}

    	.slider-btn {
    		width: 60px;
    		border-radius: 8px;
    		position: fixed;
    		bottom: 32px;
    		right: 40px;
    		z-index: 1;
    		display: flex;
    		flex-direction: column;
    		justify-content: center;
    		align-items: center;
    		font-size: 11px;
    		font-weight: 400;
    		line-height: 14px;
    		color: var(--fontHomeSliderColor);
    		background: var(--backgroudHomeSliderColor);
    		cursor: default;
    		box-shadow: 0px 4px 16px 0px #00000014;

    		.to-home, .to-top {
    			position: relative;
    			display: flex;
    			flex-direction: column;
    			justify-content: center;
    			align-items: center;
    			padding: 12px 0;
    		}

    		.icon {
    			width: 24px;
    			height: 24px;
    			margin-bottom: 4px;
    			stroke: #424242;

    			&.dark {
    				stroke: #dadadf;
    			}
    		}

    		.to-top {
    			&::before {
    				content: '';
    				width: 44px;
    				height: 1px;
    				display: block;
    				background: var(--borderTemplateColor);
    				position: absolute;
    				top: 0;
    			}
    		}
    	}
    }
</style>
<i18n>
{
	"zh": {
		"scrollTop": "继续向上滚动或点击这里返回首页",
		"templates": "社区模板",
		"all": "全部",
		"top": "返回顶部",
		"home": "返回首页"
	},
	"en": {
		"scrollTop": "Keep scrolling up or click here to return to homepage.",
		"templates": "Community Templates",
		"all": "All ",
		"top": "Top",
		"home": "Home"
	},
	"de": {
		"scrollTop": "Hochscrollen oder hier klicken, um zur Startseite zurückzukehren.",
		"templates": "Community-Vorlagen",
		"all": "Alle ",
		"top": "Oben",
		"home": "Start"
	},
	"fr": {
		"scrollTop": "Continuez à faire défiler vers le haut ou cliquez ici pour revenir à la page d'accueil.",
		"templates": "Modèles de la communauté",
		"all": "Tout ",
		"top": "Haut",
		"home": "Accueil"
	},
	"es": {
		"scrollTop": "Desplázate hacia abajo o haz clic aquí para volver a la página de inicio.",
		"templates": "Plantillas de la comunidad",
		"all": "Todo ",
		"top": "Mejores",
		"home": "Pantalla de Inicio"
	},
	"jp": {
		"scrollTop": "上にスクロールし続けるか、ここをクリックしてホームページに戻ります。",
		"templates": "コミュニティテンプレート",
		"all": "すべて ",
		"top": "トップ",
		"home": "ホーム"
	},
	"pt": {
		"scrollTop": "Continue rolando ou clique aqui para retornar à página inicial.",
		"templates": "Modelos de comunidade",
		"all": "Todos ",
		"top": "Topo",
		"home": "Início"
	},
	"it": {
		"scrollTop": "Continua a scorrere verso l'alto o fai clic qui per tornare alla homepage.",
		"templates": "Modelli della community",
		"all": "tutto ",
		"top": "In alto",
		"home": "Casa"
	},
	"tw": {
		"scrollTop": "繼續向上捲動或按一下這裡返回首頁。",
		"templates": "社群範本",
		"all": "全部",
		"top": "頂端",
		"home": "轉到主頁"
	},
	"kr": {
		"scrollTop": "계속 위로 스크롤하거나 여기를 클릭하여 홈페이지로 돌아갑니다.",
		"templates": "커뮤니티 템플릿",
		"all": "모두 ",
		"top": "위",
		"home": "메인 화면 가기"
	},
	"id": {
		"scrollTop": "Keep scrolling up or click here to return to homepage.",
		"templates": "Community Templates",
		"all": "All ",
		"top": "Top",
		"home": "Beranda"
	},
	"ru": {
		"scrollTop": "Продолжайте прокручивать страницу вверх или нажмите здесь, чтобы вернуться на главную страницу.",
		"templates": "Шаблоны сообщества",
		"all": "усё ",
		"top": "Вверх",
		"home": "Главная"
	}
}
</i18n>
